<h2 mat-dialog-title>Confirmation</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-flat-button color="primary" (click)="confirm()">Confirmer</button>
</mat-dialog-actions>
